module.exports = __webpack_public_path__ + "media/images/home/step_arrow@2x-4889396065acdf66c02040dc6508a120.png";